var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2673C0 5.63996 5.37262 0.267334 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IDR.e832dd30a1e3fd45ee8d2e38ef29fe68.svg";